module.exports = __webpack_public_path__ + "img/account_close.9b5096c0.svg";